import React from "react";
import Header from "../componets/Header";
import Footer from "../componets/Footer";

const historyDomains = [
  { domain: "GXU.COM", details: "registered 2000, Top, DynaValue: $55,710", price: "US$ 22,500" },
  { domain: "785.eu", details: "DotDB: 60, Dynadot: $12,106", price: "US$ 299" },
  { domain: "wtdk.com", details: "registered 2004, DotDB: 6, Estibot: $5,900", price: "US$ 399" },
  { domain: "jvdd.com", details: "registered 2006, DotDB: 6, Dynadot: $4,095", price: "US$ 499" },
  { domain: "xnvl.com", details: "registered 2023, GoValue: $2,187", price: "US$ 399" },
  { domain: "uoi.co", details: "registered 2014, DotDB: 58, GoValue: $2,128", price: "US$ 299" },
  { domain: "iue.co", details: "registered 2014, DotDB: 61", price: "US$ 299" },
  { domain: "ChinaBelt.com", details: "registered 1999, GoValue: $2,511", price: "US$ 299" },
  { domain: "AskingGPT.com", details: "Dynadot: $2,310", price: "US$ 299" },
  { domain: "clmbn.com", details: "GoValue: $1,761", price: "US$ 499" },
  { domain: "Seminars.biz", details: "registered 2002, DotDB: 86, GoValue: $1,710", price: "US$ 299" },
  { domain: "esr.cc", details: "registered 2010, DotDB: 140, GoValue: $1,676", price: "US$ 299" },
  { domain: "PeacefulProtester.com", details: "registered 2020, GoValue: $3,133", price: "US$ 399" },
  { domain: "ExoticMc.com", details: "registered 2013, GoValue: $3,079", price: "US$ 299" },
  { domain: "PortableOrganizer.com", details: "registered 2015, Estibot: $3,000", price: "US$ 399" },
  { domain: "CoolBanker.com", details: "registered 2007, GoValue: $2,969", price: "US$ 399" },
  { domain: "PacificConference.com", details: "registered 2003, GoValue: $2,935", price: "US$ 399" },
  { domain: "ProgressiveOptions.com", details: "registered 2002, Estibot: $2,900", price: "US$ 399" },
  { domain: "TasteStation.com", details: "registered 2007, DotDB: 6, GoValue: $2,682", price: "US$ 399" },
  { domain: "VideoGameTracker.com", details: "registered 1999, GoValue: $2,555", price: "US$ 399" },
  { domain: "MissingEpisodes.com", details: "registered 2001, Estibot: $2,500", price: "US$ 399" },
  { domain: "zwh.io", details: "DotDB: 52, GoValue: $3,377", price: "US$ 299" },
  { domain: "uvpf.com", details: "registered 2005, GoValue: $3,060", price: "US$ 399" },
];

const historyChDeDomains = [
  { domain: "cqb.ch", details: "registriert 2002, DotDB: 66, Estibot: 5.200 $", price: "EUR 399" },
  { domain: "cxm.ch", details: "registriert 2019, DotDB: 113, Estibot: 5.200 $", price: "EUR 399" },
  { domain: "lbj.ch", details: "registriert 2010, DotDB: 84, Estibot: 5.200 $", price: "EUR 399" },
  { domain: "qmd.ch", details: "registriert 2004, DotDB: 55, Estibot: 5.200 $", price: "EUR 399" },
  { domain: "yrc.ch", details: "registriert 2010, DotDB: 68, Estibot: 5.200 $", price: "EUR 399" },
  { domain: "yzs.de", details: "registriert 2020, DotDB: 46, Dynadot: 7.336 $", price: "EUR 399" },
  { domain: "qbd.de", details: "registriert 2024, DotDB: 62, Dynadot: 7.248 $", price: "EUR 399" },
  { domain: "vys.de", details: "registriert 2024, DotDB: 58, GoValue: 7.084 $", price: "EUR 399" },
  { domain: "oiq.de", details: "registriert 2019, DotDB: 34, GoValue: 6.357 $", price: "EUR 399" },
  { domain: "wcy.io", details: "registriert 2024, DotDB: 52, GoValue: 3.579 $", price: "EUR 399" },
  { domain: "zhn.io", details: "DotDB: 47, GoValue: 3.233 $", price: "EUR 399" },
  { domain: "333888.de", details: "", price: "EUR 299" },
  { domain: "89999.de", details: "", price: "EUR 299" },
];

const font = "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif";

function HistoryTable({ domains }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ borderBottom: "1px solid rgba(31,226,165,0.15)" }}>
          <th style={{ textAlign: "left", padding: "14px 32px", color: "#1FE2A5", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.15em" }}>Domain</th>
          <th style={{ textAlign: "left", padding: "14px 32px", color: "#1FE2A5", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.15em" }}>Last Price</th>
          <th style={{ textAlign: "left", padding: "14px 32px", color: "#1FE2A5", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.15em" }}>Details</th>
        </tr>
      </thead>
      <tbody>
        {domains.map((item, idx) => (
          <tr key={item.domain} style={{ borderBottom: "1px solid rgba(255,255,255,0.04)", backgroundColor: idx % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent" }}>
            <td style={{ padding: "14px 32px", color: "#fff", fontWeight: 700, fontSize: "1rem" }}>{item.domain}</td>
            <td style={{ padding: "14px 32px", color: "rgba(255,255,255,0.85)", fontSize: "1rem" }}>{item.price}</td>
            <td style={{ padding: "14px 32px", color: "rgba(255,255,255,0.4)", fontSize: "0.85rem" }}>{item.details}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function History01() {
  return (
    <div className="App">
      <Header handleSubscribe={() => {}} />
      <div className="pt-[120px] w-full">
        <div style={{ width: "100%", maxWidth: "1340px", margin: "0 auto", padding: "48px 24px", fontFamily: font }}>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 800, color: "#fff", marginBottom: "8px", fontFamily: font }}>
              Past Auctions — Archive
            </h2>
            <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "1rem", fontFamily: font }}>
              These auctions have ended. <a href="/" style={{ color: "#1FE2A5", textDecoration: "none" }}>View current auctions</a>
            </p>
          </div>

          <div style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
              Main
            </h3>
            <div style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <HistoryTable domains={historyDomains} />
            </div>
          </div>

          <div style={{ marginBottom: "56px" }}>
            <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#fff", marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px", fontFamily: font }}>
              <span style={{ width: "3px", height: "20px", borderRadius: "2px", background: "#1FE2A5", display: "inline-block" }} />
              3 Letter .CH & .DE
            </h3>
            <div style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
              <HistoryTable domains={historyChDeDomains} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default History01;
